import {createContext} from 'react';
import {CartItemPayload, CatalogComponent, LocalCart, UserRole, UserSession} from './models';

export type AuthContextType = {
    userDetails: UserSession | undefined;
    setUserDetails: (newUserSession: UserSession) => void;
    fetchSessionDetails: () => Promise<UserSession>;
    isUserPermittedForRole: (role: UserRole, session: UserSession) => boolean;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export type CartContextType = {
    setCatalogItems: (catalogItems: CatalogComponent[]) => void;
    getCatalogItems: () => CatalogComponent[];
    cart: LocalCart | undefined;
    updateCart: (itemId: string, neqQuantity: number) => void;
    clearCart: () => void;
    getCartItem: (id: string) => CartItemPayload | undefined;
    getCart: () => LocalCart | undefined;
    getCartTotal: () => number;
    setWebsiteId: (websiteId: string) => void;
    getWebsiteId: () => string;
};

export const CartContext = createContext<CartContextType | undefined>(undefined);
